import { SelectState, flattenOptions, groupOptions, SelectSearchableVariant, isIOptionGroup } from '@hse-design/core';
import { __extends, __assign, __decorate, __metadata } from 'tslib';
import { Model, Prop, Watch, Emit, Component, Vue } from 'vue-property-decorator';
import 'reflect-metadata';
import __vue_component__$3 from '../HseDropdownMenu/HseDropdownMenuDivider.vue.js';
import isFinite from 'lodash/isFinite';
import { createPopper } from '@popperjs/core';
import merge from 'lodash/merge';
import ClickOutside from '../../directives/ClickOutside.js';
import { InputSize } from '../HseInput/InputSize.js';
import { SelectWidthVariant, SelectVariant } from './types.js';
import __vue_component__$4 from './HseSelectValueContainer.vue.js';
import __vue_component__$5 from './HseSelectDropdown.vue.js';
import __vue_component__$2 from './HseSelectOptionGroup.vue.js';
import __vue_component__$1 from './HseSelectOption.vue.js';
import __vue_component__ from './HseSelectSearchInput.vue.js';

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=1091%3A190
 * @storybook /?path=/story/inputs-select--playground
 * @react /src-components-select
 * @reactStorybook /?path=/story/inputs-select--playground
 */
var HseSelect = /** @class */ (function (_super) {
    __extends(HseSelect, _super);
    function HseSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = __assign(__assign({}, SelectState.initialState), { menuOpen: _this.permanent });
        _this.selectState = new SelectState(_this.setState);
        _this.popper = undefined;
        return _this;
    }
    Object.defineProperty(HseSelect.prototype, "widthStyles", {
        get: function () {
            if (!isFinite(+this.width))
                return {};
            var width = this.width + "px";
            return {
                width: width,
                'min-width': width
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "message", {
        get: function () {
            if (this.state.error) {
                return this.errorMessage || this.state.errorMessage;
            }
            if (this.state.loading)
                return this.loadingPlaceholder;
            if (this.showNothingFoundPlaceholder)
                return this.nothingFoundPlaceholder;
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "focused", {
        get: function () {
            return (!this.disabled &&
                (this.state.rootFocused || this.state.searchInputFocused));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "showNothingFoundPlaceholder", {
        get: function () {
            return this.computedState.showNothingFoundPlaceholder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "hasAnyTags", {
        get: function () {
            return Array.isArray(this.value) && this.value.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "flatOptions", {
        get: function () {
            return flattenOptions(this.options);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "singleValueLabel", {
        get: function () {
            var _a;
            return ((!this.multiple && ((_a = this.state.selectedOptions[0]) === null || _a === void 0 ? void 0 : _a.label)) || this.value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "singleValueNotSelected", {
        get: function () {
            return this.computedState.singleValueNotSelected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "showInputInValueField", {
        get: function () {
            return this.computedState.showInputInValueField;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "showTags", {
        get: function () {
            return this.computedState.showTags;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "showSelectedValueInField", {
        get: function () {
            return this.computedState.showSelectedValueInField;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "showClearIcon", {
        get: function () {
            return this.computedState.showClearIcon;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "groupedOptions", {
        get: function () {
            return groupOptions(this.state.filteredOptions);
        },
        enumerable: false,
        configurable: true
    });
    HseSelect.prototype.mounted = function () {
        var _this = this;
        this.popper = this.createPopper();
        this.$watch(function () { return [_this.state, JSON.stringify(_this.$props)]; }, function () {
            _this.selectStateUpdate();
        }, { immediate: true });
    };
    HseSelect.prototype.updated = function () {
        if (this.popper) {
            this.popper.forceUpdate();
        }
        else {
            this.popper = this.createPopper();
        }
        this.selectStateUpdate();
    };
    HseSelect.prototype.showWarnings = function () {
        if (this.searchable === SelectSearchableVariant.inline && this.multiple) {
            // eslint-disable-next-line no-console
            console.warn("[" + this.$options.name + "] Usage of props searchable=\"inline\" and :multiple=\"true\" is not supported");
        }
    };
    HseSelect.prototype.refSearchInput = function () {
        var _a;
        return (_a = this.$refs.searchInput) === null || _a === void 0 ? void 0 : _a.refInput();
    };
    Object.defineProperty(HseSelect.prototype, "selectStateProps", {
        get: function () {
            return {
                selectedFirst: this.selectedFirst,
                permanent: this.permanent,
                searchable: this.searchable,
                clearable: this.clearable,
                options: this.flatOptions,
                getOptions: this.getOptions,
                defaultErrorMessage: this.defaultErrorMessage,
                multiple: this.multiple,
                value: this.value,
                onChange: this.onChange,
                onChangeOption: this.onChangeOption,
                onClear: this.onClear
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "computedState", {
        get: function () {
            return __assign({}, this.selectState.compute(this.state, this.selectStateProps));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelect.prototype, "selectStateArgs", {
        get: function () {
            return [this.state, this.selectStateProps];
        },
        enumerable: false,
        configurable: true
    });
    HseSelect.prototype.selectStateUpdate = function () {
        var _a, _b, _c;
        this.showWarnings();
        var _d = this.selectStateArgs, state = _d[0], props = _d[1];
        var refs = {
            container: this.$refs.container,
            searchInput: this.refSearchInput(),
            dropdown: (_a = this.$refs.dropdown) === null || _a === void 0 ? void 0 : _a.refRoot(),
            dropdownMenuItems: ((_b = this.$refs
                .dropdownMenuItems) === null || _b === void 0 ? void 0 : _b.map(function (optionInstance) {
                return optionInstance.$refs.item.refRoot();
            })) || [],
            dropdownMenuItemsContainer: (_c = this.$refs.dropdown) === null || _c === void 0 ? void 0 : _c.refItems(),
            multipleValues: this.$refs.multipleValues
        };
        this.selectState.update(state, props, refs);
    };
    HseSelect.prototype.createPopper = function () {
        var _a, _b;
        var dropdownRoot = (_a = this.$refs.dropdown) === null || _a === void 0 ? void 0 : _a.refRoot();
        if (!dropdownRoot)
            return;
        return createPopper((_b = this.$refs.valueContainer) === null || _b === void 0 ? void 0 : _b.$refs.root, dropdownRoot, {
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 8]
                    }
                }
            ]
        });
    };
    HseSelect.prototype.setState = function (newStateFn) {
        this.state = newStateFn(this.state);
    };
    HseSelect.prototype.handleKeyDown = function (e) {
        if (!this.disabled) {
            this.selectState.onKeyDown(e);
        }
        /**
         * Событие нажатия кнопки клавиатуры
         * @event keydown
         * @type {KeyboardEvent}
         */
        this.$emit('keydown', e);
    };
    HseSelect.prototype.handleFocus = function (e) {
        if (!this.disabled) {
            this.selectState.onFocus();
        }
        /**
         * Событие фокуса на компонент
         * @type {FocusEvent}
         */
        this.$emit('focus', e);
    };
    HseSelect.prototype.handleBlur = function (e) {
        if (!this.disabled) {
            if (e.target === this.$refs.container) {
                this.selectState.onBlur();
            }
        }
        /**
         * Событие потери фокуса с компонента
         * @type {FocusEvent}
         */
        this.$emit('blur', e);
    };
    HseSelect.prototype.handleSearchChange = function (e) {
        if (typeof e === 'string') {
            this.selectState.onSearchChange(e);
        }
        else if (e instanceof Event && e.target) {
            this.selectState.onSearchChange(e.target.value);
        }
    };
    HseSelect.prototype.handleSearchInputFocus = function () {
        this.selectState.onSearchInputFocus();
    };
    HseSelect.prototype.handleSearchInputBlur = function () {
        this.selectState.onSearchInputBlur();
        // blur ивент не бабблится (а в реакте – да), поэтому вызываем обработчик сами
        this.selectState.onBlur();
    };
    HseSelect.prototype.handleOptionClick = function (option) {
        this.selectState.onOptionClick(option);
    };
    HseSelect.prototype.handleOptionMouseEnter = function (option) {
        this.selectState.onOptionMouseEnter(option);
    };
    HseSelect.prototype.onClearClick = function () {
        this.selectState.onClearClick();
    };
    HseSelect.prototype.onValueClick = function (ev) {
        if (this.disabled)
            return;
        this.selectState.onValueClick(ev);
    };
    HseSelect.prototype.onClickOutside = function (e) {
        // this.selectState.onClickOutside(e);
    };
    /**
     * Событие выбранного изменения значения
     * @event change
     * @type {null | IOptionValue[] | IOptionValue}
     */
    HseSelect.prototype.onChange = function (value) {
        return value;
    };
    /**
     * Событие выбранного изменения объекта-опции
     * @event change:option
     * @type {null | ISelectOption[] | ISelectOption}
     */
    HseSelect.prototype.onChangeOption = function (value) {
        return value;
    };
    /**
     * Событие сброса выбранного значения
     * @event clear
     * @type {[] | null}
     */
    HseSelect.prototype.onClear = function (data) {
        if (!this.$listeners['clear']) {
            this.onChange(data);
            this.onChangeOption(data);
        }
        return data;
    };
    HseSelect.prototype.renderHiddenNativeSelect = function (h) {
        var _a = this, disabled = _a.disabled, multiple = _a.multiple, placeholder = _a.placeholder, state = _a.state, value = _a.value;
        return h('select', {
            attrs: {
                disabled: disabled,
                multiple: multiple,
                placeholder: placeholder,
                value: value,
                tabindex: -1
                // todo прокинуть innerProps как в реакте
            },
            staticClass: 'hse-Select__input'
        }, state.filteredOptions.map(function (o, oIndex) {
            return h('option', {
                key: "option-" + oIndex,
                attrs: {
                    value: o.value
                }
            }, [o.label]);
        }));
    };
    HseSelect.prototype.renderSearchInput = function (h, additionalData) {
        if (additionalData === void 0) { additionalData = {}; }
        return !this.searchable
            ? h()
            : h(__vue_component__, merge({
                ref: 'searchInput',
                props: {
                    type: this.searchable,
                    value: this.state.searchValue
                },
                on: {
                    input: this.handleSearchChange,
                    focus: this.handleSearchInputFocus,
                    blur: this.handleSearchInputBlur
                }
            }, additionalData));
    };
    HseSelect.prototype.renderOption = function (h, option, key) {
        var _this = this;
        var _a = this, state = _a.state, checkboxes = _a.checkboxes, multiple = _a.multiple, lineClamp = _a.lineClamp;
        var selected = state.selectedOptions.some(function (o) { return o.value === option.value; });
        return h(__vue_component__$1, {
            key: key,
            refInFor: true,
            ref: 'dropdownMenuItems',
            attrs: {
                lineClamp: lineClamp,
                disabled: option.inactive,
                selected: !(checkboxes && multiple) && selected,
                checked: checkboxes && selected,
                focused: !!state.focusedOption && option.value === state.focusedOption.value,
                leftIcon: option.leftIcon,
                rightIcon: option.rightIcon
            },
            props: {
                hasCheckbox: checkboxes && multiple
            },
            on: option.inactive
                ? {}
                : {
                    click: function () { return _this.handleOptionClick(option); },
                    'click:checkbox': function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        _this.handleOptionClick(option);
                    },
                    mouseenter: function () { return _this.handleOptionMouseEnter(option); }
                }
        }, [option.label]);
    };
    HseSelect.prototype.renderOptions = function (h, additionalData) {
        var _this = this;
        if (additionalData === void 0) { additionalData = {}; }
        var i = 0;
        var result = [];
        for (var _i = 0, _a = this.groupedOptions; _i < _a.length; _i++) {
            var option = _a[_i];
            if (isIOptionGroup(option)) {
                var group = option;
                result.push(h(__vue_component__$2, merge({
                    key: i++,
                    attrs: {
                        title: group.label
                    }
                }, additionalData), group.options.map(function (o) { return _this.renderOption(h, o, i++); })));
            }
            else {
                if (option.divided) {
                    result.push(h(__vue_component__$3, { key: i++ }));
                }
                result.push(this.renderOption(h, option, i++));
            }
        }
        return result;
    };
    // Для избавления от дублирования кода компонент использует render функцию
    HseSelect.prototype.render = function (h) {
        var _a;
        var _b = this, classes = _b.classes, size = _b.size, leftIcon = _b.leftIcon, showClearIcon = _b.showClearIcon, disabled = _b.disabled, focused = _b.focused, variant = _b.variant, state = _b.state, width = _b.width, renderSearchInput = _b.renderSearchInput, message = _b.message, searchable = _b.searchable, renderOptions = _b.renderOptions;
        return h('div', {
            ref: 'container',
            attrs: {
                tabIndex: disabled ? -1 : 0
            },
            directives: [
                {
                    name: 'click-outside',
                    value: this.onClickOutside
                }
            ],
            staticClass: 'hse-Select',
            class: (_a = {},
                _a["hse-Select_variant_" + variant] = variant,
                _a['hse-Select_opened'] = state.menuOpen,
                _a["hse-Select_width_" + width] = width === SelectWidthVariant.auto ||
                    width === SelectWidthVariant.full,
                _a),
            style: this.widthStyles,
            on: {
                keydown: this.handleKeyDown,
                focus: this.handleFocus,
                blur: this.handleBlur
            }
        }, [
            this.renderHiddenNativeSelect(h),
            h(__vue_component__$4, {
                ref: 'valueContainer',
                class: classes.valueContainer,
                props: {
                    focused: focused,
                    disabled: disabled,
                    size: size,
                    leftIcon: leftIcon,
                    selectedOptions: state.selectedOptions,
                    showTags: this.showTags,
                    focusedTagI: state.focusedTagI,
                    showSelectedValueInField: this.computedState
                        .showSelectedValueInField,
                    showPlaceholderInField: this.computedState.showPlaceholderInField,
                    showInputInValueField: this.computedState.showInputInValueField,
                    singleValueLabel: this.singleValueLabel,
                    placeholder: this.placeholder,
                    showClearIcon: showClearIcon,
                    clearButtonFocused: state.clearButtonFocused,
                    isOpen: state.menuOpen
                },
                on: {
                    click: this.onValueClick,
                    'click:clear': this.onClearClick,
                    'focus:clear': this.selectState.onClearFocus,
                    'blur:clear': this.selectState.onClearBlur
                }
            }, [
                this.computedState.showInputInValueField &&
                    renderSearchInput(h, {
                        slot: 'searchInput',
                        attrs: {
                            placeholder: this.placeholder || this.searchPlaceholder
                        }
                    })
            ]),
            !disabled &&
                h(__vue_component__$5, {
                    ref: 'dropdown',
                    props: {
                        classes: {
                            dropdownMenuMessage: classes.dropdownMenuMessage
                        },
                        isOpen: state.menuOpen,
                        message: message,
                        searchable: searchable
                    },
                    class: classes.dropdownMenu
                }, [
                    state.menuOpen &&
                        !message &&
                        renderOptions(h, { slot: 'default' }),
                    searchable === SelectSearchableVariant.dropdown &&
                        renderSearchInput(h, {
                            slot: 'header',
                            attrs: {
                                placeholder: this.searchPlaceholder
                            }
                        })
                ])
        ]);
    };
    __decorate([
        Model('change', {
            validator: function (v) { return v === null || typeof v === 'string' || Array.isArray(v); },
            default: null
        }),
        __metadata("design:type", Object)
    ], HseSelect.prototype, "value", void 0);
    __decorate([
        Prop({
            default: function () { return []; }
        }),
        __metadata("design:type", Array)
    ], HseSelect.prototype, "options", void 0);
    __decorate([
        Prop({
            default: 2
        }),
        __metadata("design:type", Object)
    ], HseSelect.prototype, "lineClamp", void 0);
    __decorate([
        Prop({
            default: true
        }),
        __metadata("design:type", Boolean)
    ], HseSelect.prototype, "selectedFirst", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseSelect.prototype, "permanent", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Object)
    ], HseSelect.prototype, "searchable", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseSelect.prototype, "disabled", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseSelect.prototype, "multiple", void 0);
    __decorate([
        Prop({
            default: null
        }),
        __metadata("design:type", Object)
    ], HseSelect.prototype, "leftIcon", void 0);
    __decorate([
        Prop({
            default: 'Ничего не найдено'
        }),
        __metadata("design:type", String)
    ], HseSelect.prototype, "nothingFoundPlaceholder", void 0);
    __decorate([
        Prop({
            default: 'Загрузка...'
        }),
        __metadata("design:type", String)
    ], HseSelect.prototype, "loadingPlaceholder", void 0);
    __decorate([
        Prop({
            default: 'Поиск'
        }),
        __metadata("design:type", String)
    ], HseSelect.prototype, "searchPlaceholder", void 0);
    __decorate([
        Prop({
            default: 'Ничего не найдено'
        }),
        __metadata("design:type", String)
    ], HseSelect.prototype, "defaultErrorMessage", void 0);
    __decorate([
        Prop({
            default: 'Выберите значение'
        }),
        __metadata("design:type", String)
    ], HseSelect.prototype, "placeholder", void 0);
    __decorate([
        Prop({
            default: true
        }),
        __metadata("design:type", Boolean)
    ], HseSelect.prototype, "clearable", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", String)
    ], HseSelect.prototype, "errorMessage", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseSelect.prototype, "checkboxes", void 0);
    __decorate([
        Prop({
            validator: function (v) { return Object.values(InputSize).includes(v); },
            default: 'medium'
        }),
        __metadata("design:type", String)
    ], HseSelect.prototype, "size", void 0);
    __decorate([
        Prop({
            validator: function (v) { return ['function', 'undefined'].includes(typeof v); },
            default: undefined
        }),
        __metadata("design:type", Object)
    ], HseSelect.prototype, "getOptions", void 0);
    __decorate([
        Prop({
            validator: function (v) { return Object.values(SelectVariant).includes(v); },
            default: 'default'
        }),
        __metadata("design:type", String)
    ], HseSelect.prototype, "variant", void 0);
    __decorate([
        Prop({
            validator: function (v) {
                return isFinite(+v) || (typeof v === 'string' && ['auto', 'full'].includes(v));
            },
            default: 280
        }),
        __metadata("design:type", Object)
    ], HseSelect.prototype, "width", void 0);
    __decorate([
        Prop({
            default: function () { return ({}); }
        }),
        __metadata("design:type", Object)
    ], HseSelect.prototype, "classes", void 0);
    __decorate([
        Watch('selectStateArgs'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HseSelect.prototype, "selectStateUpdate", null);
    __decorate([
        Emit('change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HseSelect.prototype, "onChange", null);
    __decorate([
        Emit('change:option'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HseSelect.prototype, "onChangeOption", null);
    __decorate([
        Emit('clear'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HseSelect.prototype, "onClear", null);
    HseSelect = __decorate([
        Component({
            name: 'HseSelect',
            inheritAttrs: false,
            directives: {
                ClickOutside: ClickOutside
            }
        })
    ], HseSelect);
    return HseSelect;
}(Vue));

export default HseSelect;
